import { Table, TableBody, TableCell, TableHead, TableRow, useTheme } from '@mui/material';
import { Link } from '@tanstack/react-router';

import type { Organization } from '@/modules/api/backend';

interface OrganizationTableProps {
  organizationData: Organization[];
}

export function OrganizationTable({ organizationData }: OrganizationTableProps) {
  const theme = useTheme();

  return (
    <Table aria-label="Organisationen" sx={{ minWidth: 650 }}>
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>User</TableCell>
          <TableCell>Anlagen</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {(organizationData || []).map((organization) => (
          <TableRow
            key={organization.id}
            component={Link}
            to={organization.id}
            sx={{
              textDecoration: 'none',
              cursor: 'pointer',
              '&:hover': { backgroundColor: theme.palette.action.hover },
              '& .MuiTableCell-root': {
                textDecoration: 'none',
              },
            }}
          >
            <TableCell>{organization.name}</TableCell>
            <TableCell>{organization.users?.length ?? 0}</TableCell>
            <TableCell>{organization.parkAndRideFacilities?.length ?? 0} Anlagen</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
